// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"773dc4ac","664":"2a856d33","665":"4313a913","706":"cc727622"}[chunkId] + ".chunk.js";
};